import { render } from "./draftManage.vue?vue&type=template&id=e22db142&ts=true"
import script from "./draftManage.vue?vue&type=script&lang=ts"
export * from "./draftManage.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__